module.exports = __webpack_public_path__ + "img/dinosaur.b9771e2e.svg";